module.exports = __webpack_public_path__ + "img/组 4.0ec055e1.webp";